import { pxToRem } from "@/util";
import { Box, IconButton, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import Link from "next/link"
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0),
    },
  },
  cont: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  text1: {
    fontWeight: 600,
    fontSize: pxToRem(20),
    color: "#101828",
  },
  text2: {
    fontWeight: 400,
    fontSize: pxToRem(16),
  },
  text3: {
    fontWeight: 600,
    fontSize: pxToRem(16),
    color: theme.palette.primary.main,
    width: "70%",
    fontFamily: "General Sans",
  },
  iconCont: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: pxToRem(-10),
  },
}));

export default function SocialContact() {
  const { classes } = useStyles();

  const contactInfo = [
    {
      title: "Email",
      description: "Our friendly team is here to help.",
      detail: "Info@arelhomesng.com",
    },
    {
      title: "Office",
      description: "Come and say hello at HQ or for more enquiries.",
      detail: "Plot 4 Nnanna Atuonwu Drive, Liberty Estate, Enugu",
    },
    {
      title: "Phone",
      description: "Mon-Fri from 8am to 5pm.",
      detail: "+234 906 315 7836",
    },
  ];

  const socialLinks = [
    {
      icon: "/images/consultation/Social1.svg", 
      url: "https://wa.me/2349063157836",
      alt: "WhatsApp",
    },
    {
      icon: "/images/consultation/Social2.svg", 
      url: "https://www.facebook.com/arelhomesng",
      alt: "Facebook",
    },
    {
      icon: "/images/consultation/Social3.svg", 
      url: "https://www.instagram.com/arel_homes/?igsh=Yzkwc2E4Y3NkbjN3&utm_source=qr#",
      alt: "Instagram",
    },
  ];

  return (
    <Box className={classes.container}>
      {contactInfo.map(({ title, description, detail }, index) => (
        <Box key={index} className={classes.cont}>
          <Typography className={classes.text1}>{title}</Typography>
          <Typography className={classes.text2}>{description}</Typography>
          <Typography className={classes.text3}>{detail}</Typography>
        </Box>
      ))}
      <Box>
        <Typography className={classes.text1}>Social Media</Typography>
        <Box className={classes.iconCont}>
          {socialLinks.map(({ icon, url, alt }, key) => (
            <Link
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton>
                <Image
                  src={icon}
                  width={34}
                  height={34}
                  alt={alt}
                />
              </IconButton>
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
